import { connect } from "react-redux";
import { getListMauIn, getNoiDungIn } from "actions/InChoVay";
import InChoVay from "components/CommonComponent/InChoVay";

const mapStateToProps = (state) => ({
  inchovay: state.inchovay,
});

const mapDispatchToProps = (dispatch) => ({
  getListMauIn: () => dispatch(getListMauIn()),
  getNoiDungIn: (dataSearch) => dispatch(getNoiDungIn(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InChoVay);
